import { LineChartData } from "../line-chart/LineChartProps";
import { StackInfo } from "./StackAreaLineChartProps";

export const handleStackAreaData = (
  data: LineChartData[],
  info: { [key: string]: StackInfo }
): [LineChartData[], { [key: string]: StackInfo }] => {
  const infoKeys = Object.keys(info);

  const newData = [...data];
  const newInfo = { ...info };

  const processedData = newData.map((dataPoint) => {
    // convert dataPoint to an array and sort by the second value
    const dataPointArray = Object.entries(dataPoint)
      .filter((arr) => infoKeys.includes(arr[0]))
      .sort((a, b) => Number(a[1]) - Number(b[1]));

    // subtract each value from the previous value
    // and add it to the dataPoint with a new key
    for (let i = 0; i < dataPointArray.length; i++) {
      const [key, value] = dataPointArray[i];
      if (i === 0) {
        dataPoint[`${key}_stack`] = value;
        continue;
      }

      dataPoint[`${key}_stack`] =
        Number(value) - Number(dataPointArray[i - 1][1]);
    }
    return dataPoint;
  });

  // data has been processed
  for (const key of infoKeys) newInfo[`${key}_stack`] = info[key];
  return [processedData, newInfo];
};
